import { Check } from 'lucide-react';
import { fmtPeso, type StorePaymentMethod } from '../lib/api';

/**
 * The two pick-one rows every purchase screen in the app uses: a priced option
 * (a plan or a period) and a payment method. Shared by the coaching upgrade
 * page and the course checkout so the two never drift apart.
 */
export function PlanOption({
  plan,
  selected,
  onSelect,
}: {
  plan: { label: string; price: string };
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={`flex w-full items-center justify-between gap-4 border px-4 py-3 text-left transition-colors ${
        selected
          ? 'border-gold bg-surface'
          : 'border-[rgba(16,32,26,0.22)] hover:border-[rgba(16,32,26,0.5)]'
      }`}
    >
      <span className="text-[0.95rem] text-ink">{plan.label}</span>
      <span className="font-display text-[1.1rem] text-ink">{fmtPeso(plan.price)}</span>
    </button>
  );
}

export function MethodOption({
  method,
  selected,
  onSelect,
}: {
  method: StorePaymentMethod;
  selected: boolean;
  onSelect: () => void;
}) {
  const note =
    method.settlement === 'gateway'
      ? 'Pay online'
      : method.settlement === 'wallet'
        ? `Wallet balance ${fmtPeso(method.balance ?? '0')}`
        : (method.accountLabel ?? 'Send your payment, then upload the proof');
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={`flex w-full items-start justify-between gap-4 border px-4 py-3 text-left transition-colors ${
        selected
          ? 'border-gold bg-surface'
          : 'border-[rgba(16,32,26,0.22)] hover:border-[rgba(16,32,26,0.5)]'
      }`}
    >
      <span className="min-w-0">
        <span className="block text-[0.95rem] text-ink">{method.label}</span>
        <span className="eyebrow mt-1 block">{note}</span>
      </span>
      {selected && <Check className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden />}
    </button>
  );
}
